<template>
  <transition name="fade">
    <div v-if="visible" class="fixed" @click="closePopup">
      <div class="modal-card" @click.stop>
        <Vue3Lottie :animationData="SuccessJSON" :height="90" :width="90" />
        <h3 style="font-size: 1.35rem; font-weight: 700; color: var(--text-color-dark); margin-top: 0.5rem; margin-bottom: 0.35rem;">
          ¡Reserva Canjeada!
        </h3>
        <p style="font-size: 14px; color: var(--text-color-light); margin-bottom: 1.5rem;">
          Has canjeado la reserva correctamente.
        </p>
        <button @click="acceptPopup" class="main_button-green w-full" style="padding: 11px;">
          Aceptar
        </button>
      </div>
    </div>
  </transition>
</template>

<script setup>
import { ref, watch, defineProps } from 'vue';
import { Vue3Lottie } from 'vue3-lottie';
import SuccessJSON from '@/assets/anim/success_animation.json';

const props = defineProps({
  redeemSuccessVisible: Boolean
});

const visible = ref(false);

watch(() => props.redeemSuccessVisible, (newVal) => {
  visible.value = !!newVal;
});

const acceptPopup = () => {
  visible.value = false;
};

const closePopup = () => {
  visible.value = false;
};
</script>

<style scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.25s cubic-bezier(0.4, 0, 0.2, 1);
}
.fade-enter-from, .fade-leave-to {
  opacity: 0;
}

.modal-card {
  background-color: var(--white);
  padding: 1.75rem;
  border-radius: var(--radius-md);
  box-shadow: var(--shadow-xl);
  width: 90%;
  max-width: 400px;
  text-align: center;
  border: 1px solid var(--border-color);
  animation: slideUp 0.25s cubic-bezier(0.16, 1, 0.3, 1);
}

@keyframes slideUp {
  from { transform: translateY(12px) scale(0.98); opacity: 0; }
  to { transform: translateY(0) scale(1); opacity: 1; }
}
</style>
  